/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Cmp_DescInputs */

const en_vc_page_cmp_desc = /** @type {(inputs: Vc_Page_Cmp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft vs Adobe Illustrator compared: price, platforms, .ai and SVG support, drawing tools, AI automation and maturity. Where the free open-source editor wins and where Illustrator still leads.`)
};

const zh_vc_page_cmp_desc = /** @type {(inputs: Vc_Page_Cmp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 与 Adobe Illustrator 全面对比：价格、平台、.ai 与 SVG 支持、绘图工具、AI 自动化和成熟度。看看免费开源软件赢在哪里，Illustrator 又强在哪里。`)
};

/**
* | output |
* | --- |
* | "VectorCraft vs Adobe Illustrator compared: price, platforms, .ai and SVG support, drawing tools, AI automation and maturity. Where the free open-source edito..." |
*
* @param {Vc_Page_Cmp_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_cmp_desc = /** @type {((inputs?: Vc_Page_Cmp_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Cmp_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_cmp_desc(inputs)
	return zh_vc_page_cmp_desc(inputs)
});
export { vc_page_cmp_desc as "vc.page.cmp.desc" }